"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _heroBrand = _interopRequireDefault(require("../styles/hero-brand.css"));
var _heroBrand2 = _interopRequireDefault(require("./hero-brand.props/hero-brand.defaultProps"));
var _heroBrand3 = _interopRequireDefault(require("./hero-brand.props/hero-brand.propTypes"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageTransforms = dataUtils.appendImageTransforms;
var checkClass = function checkClass(className) {
  return className || '';
};
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var imageWidth = 480;
var HeroFeatureBlock = function HeroFeatureBlock(_ref // eslint-disable-line
) {
  var theme = _ref.theme,
    data = _ref.data,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: applyDarkTheme(data, theme) + " " + (data.textBlockPosition !== 'center' && _heroBrand["default"].featureBreak) + " " + _heroBrand["default"].featureRow
  }, data.featureBlock && data.featureBlock.map(function (feature, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      className: _heroBrand["default"].feature
    }, feature.image.image && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      src: appendImageTransforms(handleNestedProp(feature, 'feature.image.image'), imageWidth),
      alt: handleNestedProp(feature, 'feature.image.altText') || ''
    }), feature.icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: checkClass(theme["mmcIcon" + feature.icon]) + " " + _heroBrand["default"].adjustIconPositionFeatureBlock
    }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "p",
      text: feature.description,
      className: theme.labelMedium,
      disclaimerData: disclaimerData
    }));
  }));
};
HeroFeatureBlock.defaultProps = {
  theme: {},
  data: _heroBrand2["default"]
};
var _default = HeroFeatureBlock;
exports["default"] = _default;